export function SkipToContent() {
    return (
        <a
            href="#main-content"
            className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-[#1B365D] focus:text-white focus:rounded focus:text-[14px] focus:font-semibold focus:shadow-lg"
        >
            Skip to main content
        </a>
    );
}
